<template>
  <div :class="$style.box">
    <SectionTitle :class="$style.box__title">営業資料</SectionTitle>
    <div :class="$style.box__content">
      <SalesMaterialDocumentList
        :documents="documents"
        @click="clickDocument"
        @click-video="clickVideo"
      />

      <DocumentModal
        :isOpened="isModalOpened"
        :fileUrl="fileUrl"
        @close="closeModal"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import {
  type SalesMaterialViewSolicitorCloudSalesMaterialFragment,
  useGetSalesMaterialViewDocumentFileUrlLazyQuery,
} from './SalesMaterialView.generated'
import SalesMaterialDocumentList from './SalesMaterialDocumentList.vue'
import type { Document } from './SalesMaterialDocumentList.vue'
import DocumentModal from './DocumentModal.vue'
import { computed, ref } from 'vue'
import { useLogger } from '@/logger/logger'

const props = defineProps<{
  salesMaterials: SalesMaterialViewSolicitorCloudSalesMaterialFragment[]
}>()

const fileUrl = ref<string | null>(null)
const isModalOpened = ref<boolean>(false)

const logger = useLogger()

const closeModal = () => {
  fileUrl.value = null
  isModalOpened.value = false
}

const { load, onResult } = useGetSalesMaterialViewDocumentFileUrlLazyQuery({
  ids: [],
})

onResult(result => {
  fileUrl.value =
    result.data?.solicitorCloudSalesMaterialsByIds?.[0].fileUrl ?? null
})

const clickDocument = async ({
  id,
}: {
  id: SalesMaterialViewSolicitorCloudSalesMaterialFragment['id']
}) => {
  isModalOpened.value = true

  load(
    undefined,
    {
      ids: [id],
    },
    {
      fetchPolicy: 'no-cache',
    }
  )

  logger.ltlPeople.event.clickSolicitorCloudDocument(logger.buildMeta(), {
    data: { id, type: 'sales-material-document' },
  })
}

const clickVideo = async ({
  id,
}: {
  id: SalesMaterialViewSolicitorCloudSalesMaterialFragment['id']
}) => {
  logger.ltlPeople.event.clickSolicitorCloudDocument(logger.buildMeta(), {
    data: { id, type: 'sales-material-video' },
  })
}

const documents = computed<Document[]>((): Document[] => {
  return props.salesMaterials.map(
    ({ id, title, youtubeUrl, pdfFilePath, updatedAt }): Document => ({
      id,
      title,
      pdfFilePath: pdfFilePath ?? undefined,
      youtubeUrl: youtubeUrl ?? undefined,
      updatedAt,
    })
  )
})
</script>

<style lang="scss" module>
.box {
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  background-color: $color-surface-primary;

  &__content {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $color-border-low-emphasis;
  }
}
</style>
